export default __webpack_public_path__ + "static/media/no_notification_image.67463caa.svg";